$(document).ready(function() {
  // This fix is just for the home page, as far as I can tell
  // seems to be a race condition with sprockets vs webpack
  if(typeof RedactorPlugins == 'undefined') {
    return;
  }

  RedactorPlugins.embed = function() {

    return {
      reUrlYoutube: /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube\.com\S*[^\w\-\s])([\w\-]{11})(?=[^\w\-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/ig,
      reUrlVimeo: /https?:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/,

      getTemplate: function() {
        return String()
        + '<section id="redactor-modal-embed-insert">'
          + '<form name="redactor-modal-embed-form">'
            + '<label>Embed Code, Vimeo, or YouTube url</label>'
            + '<textarea id="redactor-insert-embed-area" style="height: 160px;"></textarea>'
            + '<div class="row">'
              + '<div class="col-xs-6">'
                + '<label>View Options</label>'
                + '<select name="redactor-embed-action" class="selectpicker">'
                  + '<option value="none" selected>Default (None)</option>'
                  + '<option value="enableFullscreen">Allow Open In Fullscreen (desktop only)</option>'
                  + '<option value="enableNewTab">Allow Open In New Tab</option>'
                  + '<option value="enableModal">Allow Open In Modal</option>'
                + '</select>'
              + '</div>'
              + '<div class="col-xs-6">'
                + '<label>Aspect Ratio</label>'
                + '<select name="redactor-aspect-ratio" class="selectpicker">'
                  + '<option value="none" selected>Default (None)</option>'
                  + '<option value="16by9">16x9</option>'
                  + '<option value="4by3">4x3</option>'
                + '</select>'
              + '</div>'
            + '</div>'
          + '</form>'
        + '</section>';
      },

      init: function() {
        var button = this.button.addAfter('image', 'embed', 'Embed');
        button.addClass('kf kf-embed');
        this.button.addCallback(button, this.embed.show);
      },

      show: function() {
        this.modal.addTemplate('embed', this.embed.getTemplate());

        this.modal.load('embed', 'Embed', 700);
        this.modal.createCancelButton();

        var button = this.modal.createActionButton(this.lang.get('insert'));
        button.on('click', this.embed.insert);

        this.selection.save();
        this.modal.show();

        $('#redactor-insert-embed-area').focus();
        Kadenze.WebApp.initFormElements($('#redactor-modal')); // Enabling the form elements
      },

      insert: function() {
        var data = $('#redactor-insert-embed-area').val(),
          embedAction = $('[name="redactor-embed-action"]').val(),
          aspectRatio = $('[name="redactor-aspect-ratio"]').val();

        if (!data.match(/<iframe|<video/gi)) {
          data = this.clean.stripTags(data);

          // parse if it is link on youtube & vimeo
          var iframeStart = '<iframe style="width: 100%; height: 100%;" src="',
            iframeEnd = '" frameborder="0" allowfullscreen></iframe>';

          if (data.match(this.embed.reUrlYoutube)) {
            data = data.replace(this.embed.reUrlYoutube, iframeStart + '//www.youtube.com/embed/$1' + iframeEnd);
          } else if (data.match(this.embed.reUrlVimeo)) {
            data = data.replace(this.embed.reUrlVimeo, iframeStart + '//player.vimeo.com/video/$2' + iframeEnd);
          } else {
            data = iframeStart + data + iframeEnd;
          }
        }

        if(embedAction && embedAction != 'none') {
          var actionConfig = {
            data: {},
            iframe: data
          };

          actionConfig.data[embedAction] = true;
          data = Kadenze.IframeUtils.decorateForActions(actionConfig);
        }
        
        if(aspectRatio && aspectRatio != 'none') {
          data = Kadenze.IframeUtils.makeResponsive({ iframe: data, aspectRatio: aspectRatio });
        }

        this.selection.restore();
        this.modal.close();

        var current = this.selection.getBlock() || this.selection.getCurrent();

        if (current) {
          $(current).after(data);
        } else {
          this.insert.html(data);
        }

        this.code.sync();
      }
    };
  };

  RedactorPlugins.codeEditor = function() {

    return {
      init: function() {
        var $button = this.button.add('code-editor', 'Code Editor');

        $button.addClass('kf kf-file-code');

        this.button.addCallback($button, this.codeEditor.show);
      },

      show: function() {
        var UUID = 'code-editor-' + Kadenze.Util.UUID(100);

        this.modal.addTemplate('codeEditor', $('<section />', { id: UUID }) );
        this.modal.load('codeEditor', 'Code Editor', 1000);
        this.modal.createCancelButton();

        this.codeEditor.$editor = $('#' + UUID);

        if(this.codeEditor.session) {
          this.codeEditor.showEdit();
        } else {
          this.codeEditor.showAdd();
        }

        this.selection.save();

        this.modal.show();
        this.codeEditor.prepareEditor(this.codeEditor.$editor[0]);
      },

      update: function() {
        this.selection.save();
        this.codeEditor.session.curBlock.remove();
        this.codeEditor.insert();
        this.codeEditor.session = null;
      },

      showEdit: function() {
        var updateButton = this.modal.createActionButton('Update');
        updateButton.on('click', this.codeEditor.update);
        this.codeEditor.session.curBlock = this.selection.getBlock();
      },

      showAdd: function() {
        var button = this.modal.createActionButton('Insert');
        button.on('click', this.codeEditor.insert);
      },

      insert: function() {
        var $codeBlock = this.codeEditor.buildCodeBlock();

        this.modal.close();
        this.selection.restore();
        this.insert.node($codeBlock);
        this.code.sync();

        // This feature is still a WIP
        //this.codeEditor.enableEditing($codeBlock);

        Prism.highlightAll();
      },

      prepareEditor: function(node) {
        Kadenze.CodeEditor.init(node, { autoFocus: true });

        if(this.codeEditor.session) {
          var editor = this.codeEditor.$editor.data('codeEditor');

          editor.setValue(this.codeEditor.session.content);
          editor.setSyntax(this.codeEditor.session.syntax);
        }
      },

      enableEditing: function($node) {
        this.$editor.find('pre').off('click.codeEditor').on('click.codeEditor', { $el: $node }, this.codeEditor.edit);
      },

      edit: function(event) {
        this.codeEditor.session = {
          $el: event.data.$el,
          syntax: this.codeEditor.getSyntax(event.data.$el),
          content: event.data.$el.text()
        };

        this.codeEditor.show();
      },

      buildCodeBlock: function() {
        var editor = this.codeEditor.$editor.data('codeEditor'),
          editorValue = editor.getValue(),
          editorSyntax = editor.prismClass(),
          $pre = $('<pre />', { class: editorSyntax }),
          $code = $('<code />',{ class: editorSyntax }).html(editorValue);

        return $pre.append($code);
      },

      getSyntax: function($node) {
        return $node.prop('class').split('-')[1];
      }

    };
  }; // end codeEditor

});
